module.exports = __webpack_public_path__ + "static/img/head.067374ca.gif";